import React from 'react';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { Link } from '@uhg-abyss/web/ui/Link';
import { event } from '@uhg-abyss/web/tools/event';

const Wrapper = styled('div', {
  '.abyss-descriptors-error-message': {
    fontSize: '13px ',
    fontWeight: '400',
  },
});

const Title = styled('h2', {
  color: 'rgb(0, 38, 119)',
  fontSize: '25.63px !important',
  fontWeight: '700',
  minHeight: '32px',
  lineHeight: '32px',
  marginBottom: '5px',
});

const StyledLink = styled(Link, {});
const fireClickEvent = () => {
  const fileName = 'API Self-Paced User Guide';
  const fileURL =
    'https://chameleoncloud4.io/review/prod/baf8e197-2446-446f-a594-f27efaae8036';
  const fileContext = 'self paced chameleon guide';
  event('DOWNLOAD_CLICK', {
    event,
    fileName,
    fileURL,
    fileContext,
  });
};

export const Completed = () => {
  const form = useForm();
  const meetingDetails = form.getValues('meeting');

  const meetingDateTimeString = `${meetingDetails?.preferredMeetingDate} at ${meetingDetails?.preferredMeetingTime} EST`;
  return (
    <Wrapper>
      <div style={{ textAlign: 'left', marginLeft: '20px' }}>
        <IconBrand
          icon="checkmark"
          style={{ marginBottom: '20px' }}
          size={100}
        />
        <Title style={{ marginBottom: '10px' }}>
          Thank you for your submission
        </Title>
        <p style={{ fontSize: '15px' }}>
          Please be sure to set your reminder, we look forward to meet with you
          on {meetingDateTimeString}.
        </p>
        <p style={{ fontSize: '15px' }}>
          In the meantime, check out our{' '}
          <StyledLink
            href="https://chameleoncloud4.io/review/prod/baf8e197-2446-446f-a594-f27efaae8036"
            openNewWindow
            hideIcon
            onClick={fireClickEvent}
          >
            API Self-Paced User Guide
          </StyledLink>{' '}
          to learn more about APIs.
        </p>
      </div>
    </Wrapper>
  );
};
